export default {
  get name(): string {
    return 'ExponentStoreReview';
  },
  get isSupported(): boolean {
    return false;
  }
};
